const slidePopup = () => {
  let scrollPos = 0;

  $(".learn-more, .map-img-bg-circle").on("click", function(e) {
    e.preventDefault();
    $($(this).attr("href")).addClass("open");
    let windowWidth = $(window).width();

    if (windowWidth <= 767) {
      scrollPos =
        pageYOffset ||
        (document.documentElement.clientHeight
          ? document.documentElement.scrollTop
          : document.body.scrollTop);
      $("body").css({
        overflow: "hidden",
        width: "100%",
        position: "fixed",
        top: -scrollPos,
      });
    }
  });

  $(".close").on("click", function() {
    $(".panel-popup").removeClass("open");
    $("body").css({
      overflow: "",
      width: "",
      position: "",
      top: "",
    });
    if (scrollPos !== 0) {
      $(window).scrollTop(scrollPos);
    }
  });

  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      $(".panel-popup").removeClass("open"); // esc
      $("body").css({
        overflow: "",
        width: "",
        position: "",
        top: "",
      });
    }
  });
};

export default slidePopup;



// WEBPACK FOOTER //
// ./scripts/modules/slidePopup.js